import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-xl px-3 py-2 shadow-warm-md border border-surface-200 text-sm space-y-1">
      <p className="font-semibold text-ink-800">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="text-ink-500 flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
          <span>{p.name}:</span>
          <span className="font-medium">{(p.value || 0).toLocaleString()}</span>
        </p>
      ))}
    </div>
  );
};

const EngagementBreakdown = ({ stats }) => {
  const data = (stats || []).map((s) => ({
    date: s.date?.slice(5) || s.id?.slice(5),
    expenses: s.expensesCreated || 0,
    messages: s.messagesCreated || 0,
    activities: s.activitiesCreated || 0,
    chores: s.choreCompletions || 0,
    swaps: s.swapsCreated || 0,
  }));

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-bold text-ink-900 text-[0.9375rem]">Feature usage</h3>
        <span className="text-xs text-ink-400">Last 30 days</span>
      </div>
      <p className="text-xs text-ink-400 mb-5">
        Daily writes by feature area. Reveals which surfaces drive engagement.
      </p>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e0d6" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#57534e' }} axisLine={{ stroke: '#e5e0d6' }} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: '#57534e' }} axisLine={false} tickLine={false} allowDecimals={false} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(27, 107, 74, 0.05)' }} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
          <Bar dataKey="expenses" name="Expenses" fill="#F2886D" radius={[3, 3, 0, 0]} />
          <Bar dataKey="messages" name="Messages" fill="#3BA676" radius={[3, 3, 0, 0]} />
          <Bar dataKey="activities" name="Activities" fill="#1B6B4A" radius={[3, 3, 0, 0]} />
          <Bar dataKey="chores" name="Chore completions" fill="#F5C842" radius={[3, 3, 0, 0]} />
          <Bar dataKey="swaps" name="Swap requests" fill="#6C8FB5" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EngagementBreakdown;
